import {
  type NodeView,
  type Node as ProseMirrorNode,
} from '@progress/kendo-editor-common'

import {
  authorizationRequiredPathPrefix,
  exists,
  setAuthorizedSrc,
} from '~/utils'

type ImageViewParams = {
  getAuthorization: () => Promise<string>
  node: ProseMirrorNode
}

export class ImageView implements NodeView {
  readonly dom = document.createElement('img')

  constructor({ getAuthorization, node }: ImageViewParams) {
    const setup = async () => {
      for (const [key, value] of Object.entries(node.attrs)) {
        if (!exists(value)) {
          continue
        }

        if (
          key === 'src' &&
          typeof value === 'string' &&
          value.startsWith(authorizationRequiredPathPrefix)
        ) {
          await setAuthorizedSrc({
            element: this.dom,
            getAuthorization,
            src: value,
          })
        } else {
          this.dom.setAttribute(key, value)
        }
      }
    }

    setup()
  }
}
